import React, { useState } from "react";
import { Link, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Building2, Library, ScrollText, CreditCard, Settings, LogOut } from "lucide-react";

const NAV = [
    { to: "/partner", icon: LayoutDashboard, label: "Dashboard", end: true },
    { to: "/partner/companies", icon: Building2, label: "Companies" },
    { to: "/partner/library", icon: Library, label: "Assessment Library" },
    { to: "/partner/audit", icon: ScrollText, label: "Audit" },
    { to: "/partner/billing", icon: CreditCard, label: "Billing" },
    { to: "/partner/settings", icon: Settings, label: "Settings" },
];

export const PartnerSidebar = () => {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const isActive = (to, end) => end ? loc.pathname === to : loc.pathname.startsWith(to);

    return (
        <aside className="w-56 min-h-screen bg-card border-r border-border/40 flex flex-col fixed left-0 top-0" data-testid="partner-sidebar">
            <div className="p-5 border-b border-border/40">
                <Link to="/" className="text-lg font-bold text-white font-body">Realloc</Link>
                <p className="text-xs text-gray-600 mt-0.5 font-mono uppercase tracking-wider">Partner</p>
            </div>
            <nav className="flex-1 py-4 space-y-1 px-2">
                {NAV.map(item => (
                    <Link key={item.to} to={item.to}
                        className={`flex items-center gap-3 px-3 py-2 text-sm rounded transition-colors ${
                            isActive(item.to, item.end) ? "bg-white/10 text-white" : "text-gray-500 hover:text-white hover:bg-white/5"
                        }`}
                        data-testid={`partner-nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}>
                        <item.icon className="w-4 h-4" />
                        {item.label}
                    </Link>
                ))}
            </nav>
            <div className="p-4 border-t border-border/40 flex items-center justify-between">
                <span className="text-xs text-gray-600 truncate">{user?.full_name}</span>
                <button onClick={() => { logout(); nav("/"); }} className="text-gray-600 hover:text-white"
                    data-testid="partner-logout-btn">
                    <LogOut className="w-4 h-4" />
                </button>
            </div>
        </aside>
    );
};

export default function PartnerLayout() {
    return (
        <div className="flex bg-bg min-h-screen">
            <PartnerSidebar />
            <main className="ml-56 flex-1 p-8 min-h-screen">
                <Outlet />
            </main>
        </div>
    );
}
